import { __awaiter, __generator } from "tslib";
import { fetchSwayConfig } from '@office-start/sway-config-service';
export function getSwayOptions(officeComponentContext, identity) {
    return __awaiter(this, void 0, void 0, function () {
        var swayConfig;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchSwayConfig()];
                case 1:
                    swayConfig = _a.sent();
                    if (!officeComponentContext || !swayConfig || !identity) {
                        return [2 /*return*/, Promise.resolve(undefined)];
                    }
                    return [2 /*return*/, {
                            apiUrl: swayConfig.apiUrl,
                            correlationId: officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.correlationId,
                            userPrincipalName: identity.userPrincipalName || '',
                            authType: identity.authType,
                            jwtAuthEnabled: officeComponentContext.jwtAuthEnabled,
                            getAccessToken: officeComponentContext.getAccessToken,
                            officeHomeApiRoot: officeComponentContext.officeHomeApiRoot,
                        }];
            }
        });
    });
}
//# sourceMappingURL=getSwayOptions.js.map